import PropTypes from 'prop-types'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import './TraitLevelFilter.css'

const TraitLevelFilter = ({ className, name, onChange, value }) => {
    const classNames = `trait-level-filter ${className ?? ''}`

    return (
        <RadioGroup name={name} value={value} onChange={onChange} className={classNames}>
            <FormControlLabel
                className="label"
                control={<Radio className="radio" />}
                value="all"
                label="Basic"
            />
            <FormControlLabel
                className="label"
                control={<Radio className="radio" />}
                value="advanced"
                label="Advanced"
            />
            <FormControlLabel
                className="label"
                control={<Radio className="radio" />}
                value="elite"
                label="Elite"
            />
            <FormControlLabel
                className="label"
                control={<Radio className="radio" />}
                value="exalted"
                label="Exalted"
            />
        </RadioGroup>
    )
}

TraitLevelFilter.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
}

export default TraitLevelFilter
